import useDefaultToast from '@/components/useDefaultToast'
import { sendAuthRequest, SendAuthRequestResult } from '@/lib/wechat'
import { loginViaThirdPartyThunk } from '@/redux/slices/sessionSlice'
import { useAppDispatch } from '@/redux/store'
import { isFulfilled } from '@reduxjs/toolkit'
import { useRouter } from 'expo-router'
import { TFunction } from 'i18next'
import handleLoginResult from './handleLoginResult'

type HandleWechatLoginArgs = {
  toast: ReturnType<typeof useDefaultToast>
  dispatch: ReturnType<typeof useAppDispatch>
  router: ReturnType<typeof useRouter>
  t: TFunction<'login'>
}

export default async function handleWechatLogin({ toast, dispatch, router, t }: HandleWechatLoginArgs) {
  let authResult: SendAuthRequestResult
  try {
    authResult = await sendAuthRequest()
  } catch {
    toast.show(t('loginFailed'))
    return
  }
  if (!authResult.success) {
    if (authResult.error === 'unavailable' || authResult.error === 'wechat_not_installed') {
      toast.show('微信未安装')
    } else if (authResult.error === 'auth_failed') {
      toast.show('微信授权失败: ' + (authResult.message || '未知错误'))
    }
    return
  }

  const result = await dispatch(
    loginViaThirdPartyThunk({
      code: authResult.data.code,
      provider: 'wechat',
      platform: 'wechat_cyborg',
    })
  )
  if (isFulfilled(result)) {
    handleLoginResult({ router, loginResult: result.payload })
  } else {
    if (result.payload?.usersNotExist) {
      router.push(`/login/complete_registration?code=${encodeURIComponent(authResult.data.code)}&provider=wechat`)
    } else {
      toast.show(t('loginFailed'))
    }
  }
}
